/*
 * @Author: Dom
 * @Date: 2022-05-18 18:15:06
 * @LastEditTime: 2022-07-03 00:32:16
 * @LastEditors: Dom
 * @FilePath: \seller-web\src\views\personal\component\enterprise\locales\en-US.ts
 */
export default {
    'page.personal.center.compontent.enterprise.message' : 'Enterprise information',
    'page.personal.center.compontent.enterprise.enterpriseName' : 'Enterprise name',
    'page.personal.center.compontent.enterprise.representative' : 'Name of legal representative',
    'page.personal.center.compontent.enterprise.creditCode' : 'Unified social credit code',
    'page.personal.center.compontent.enterprise.validity' : 'Unified social letter of credit validity',
    'page.personal.center.compontent.enterprise.name' : 'Contact name',
    'page.personal.center.compontent.enterprise.email':'Mailbox',
    'page.personal.center.compontent.enterprise.phone':'Contact number',
    'page.personal.center.compontent.enterprise.address':'Contact mawb',
    'page.personal.center.compontent.enterprise.addressMod':'Detailed mawb',
    'page.personal.center.compontent.enterprise.select':'Please select',
    'page.personal.center.compontent.enterprise.businessLicense':'Upload the scanned copy of the company\'s business license',
    'page.personal.center.compontent.enterprise.size':'File size no more than 6M',
    'page.personal.center.compontent.enterprise.support':'File format support',
    'page.personal.center.compontent.enterprise.businessLicenseMod':'Please upload a clearly visible copy of your business license',
    'page.personal.center.compontent.enterprise.submit':'Submit',
    'page.personal.center.compontent.enterprise.reset':'Reset',

}
